export const ArenaNavigationPlacement = {
	TOP: 'top',
	SUB: 'sub',
};
